<div class="d-flex flex-column h-100 modal-content">
  <apm-windowed-spinner [show]="isLoading()"></apm-windowed-spinner>

  @if (entityDetails(); as attributes) {
    <div class="container-title">
      <h4 class="fw-bold apm-text-red mb-2">{{ dialogData.modelName }}</h4>
      <div class="container-tab position-relative">
        <mat-tab-group class="mb-3 pt-2">
          <mat-tab label="{{ '445056' | apmTranslate }}">
            <ng-container *ngTemplateOutlet="info"></ng-container>
          </mat-tab>
          @if (attributes['4']) {
            <mat-tab label="{{ '445057' | apmTranslate }}">
              <ng-container *ngTemplateOutlet="features"></ng-container>
            </mat-tab>
          }
          @if (attributes['5']) {
            <mat-tab label="{{ '445058' | apmTranslate }}">
              <ng-container *ngTemplateOutlet="versions"></ng-container>
            </mat-tab>
          }
          @if (attributes['6']) {
            <mat-tab label="{{ '445059' | apmTranslate }}">
              <ng-container *ngTemplateOutlet="configurations"></ng-container>
            </mat-tab>
          }
          @if (attributes['7']) {
            <mat-tab label="{{ '445060' | apmTranslate }}">
              <ng-container *ngTemplateOutlet="accessories"></ng-container>
            </mat-tab>
          }
          @if (attributes['8']) {
            <mat-tab label="{{ '445061' | apmTranslate }}">
              <ng-container *ngTemplateOutlet="commands"></ng-container>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
    <ng-template #info>
      <div class="mt-4 model-info-details-container">
        @if (attributes) {
          <div class="w-100 py-2">
            <div class="row m-0">
              @if (attributes['1']) {
                <div class="col-12 col-lg-4">
                  @for (attribute of attributes['1']; track attribute) {
                    <div class="h-100">
                      @if (attribute.image1Id !== 0) {
                        <div class="h-100 d-flex align-items-center justify-content-center">
                          <ng-container
                            *ngTemplateOutlet="
                              imageDisplay;
                              context: { $implicit: attribute.image1Id, imageClass: 'w-100 entity-image me-2' }
                            "
                          ></ng-container>
                        </div>
                      }
                      @if (attribute.image2Id !== 0) {
                        <div class="d-flex align-items-center justify-content-center">
                          <ng-container
                            *ngTemplateOutlet="
                              imageDisplay;
                              context: { $implicit: attribute.image2Id, imageClass: 'w-100 entity-image me-2' }
                            "
                          ></ng-container>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <div class="col-12" [ngClass]="getMainContentClasses(!!attributes['1'])">
                @for (attribute of attributes['2']; track attribute) {
                  <div>
                    @if (attribute.text1Id !== 0) {
                      <h3 class="d-block w-100">{{ attribute.text1Id | apmTranslate }}</h3>
                    }
                    @if (attribute.text2Id !== 0) {
                      <h3 class="d-block w-100">{{ attribute.text2Id | apmTranslate }}</h3>
                    }
                    @if (attribute.text3Id !== 0) {
                      <h3 class="d-block w-100">{{ attribute.text3Id | apmTranslate }}</h3>
                    }
                  </div>
                }
                <hr class="gray-divider-1" />
                <div class="d-flex align-items-center flex-wrap">
                  @for (attribute of attributes['9']; track attribute) {
                    <div class="mt-2">
                      @if (attribute.image1Id !== 0) {
                        <div>
                          <ng-container
                            *ngTemplateOutlet="
                              imageDisplay;
                              context: { $implicit: attribute.image1Id, imageClass: 'w-100 entity-icons me-2' }
                            "
                          ></ng-container>
                        </div>
                      }
                      @if (attribute.image2Id !== 0) {
                        <div>
                          <ng-container
                            *ngTemplateOutlet="
                              imageDisplay;
                              context: { $implicit: attribute.image2Id, imageClass: 'w-100 entity-icons me-2' }
                            "
                          ></ng-container>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <hr class="gray-divider-1 my-4" />
              @for (attribute of attributes['3']; track attribute) {
                <div>
                  @if (attribute.text1Id !== 0) {
                    <div class="d-block w-100">{{ attribute.text1Id | apmTranslate }}</div>
                  }
                  @if (attribute.text2Id !== 0) {
                    <div class="d-block w-100">{{ attribute.text2Id | apmTranslate }}</div>
                  }
                  @if (attribute.text3Id !== 0) {
                    <div class="d-block w-100">{{ attribute.text3Id | apmTranslate }}</div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>
    <!-- Reusable template for image display -->
    <ng-template #imageDisplay let-imageId let-imageClass="imageClass">
      @if (imageId) {
        <img [class]="imageClass" [title]="hasDebugPermission ? imageId : ''" [apmResourceImage]="imageId" />
      } @else {
        <div>( {{ imageId }} )</div>
      }
    </ng-template>

    <!-- Reusable template for text-based attribute sections -->
    <ng-template #textAttributeSection let-attributeList>
      <div class="mt-4 model-info-details-container">
        @for (attribute of attributeList; track attribute) {
          <div class="mt-3">
            @if (attribute.text1Id !== 0) {
              <div class="d-block w-100 mt-1">{{ attribute.text1Id | apmTranslate }}</div>
            }
            @if (attribute.text2Id !== 0) {
              <div class="d-block w-100 mt-1">{{ attribute.text2Id | apmTranslate }}</div>
            }
            @if (attribute.text3Id !== 0) {
              <div class="d-block w-100 mt-1">{{ attribute.text3Id | apmTranslate }}</div>
            }
          </div>
        }
      </div>
    </ng-template>

    <ng-template #features>
      @if (attributes['4']) {
        <ng-container *ngTemplateOutlet="textAttributeSection; context: { $implicit: attributes['4'] }"></ng-container>
      }
    </ng-template>

    <ng-template #versions>
      @if (attributes['5']) {
        <ng-container *ngTemplateOutlet="textAttributeSection; context: { $implicit: attributes['5'] }"></ng-container>
      }
    </ng-template>

    <ng-template #configurations>
      @if (attributes['6']) {
        <ng-container *ngTemplateOutlet="textAttributeSection; context: { $implicit: attributes['6'] }"></ng-container>
      }
    </ng-template>

    <ng-template #accessories>
      @if (attributes['7']) {
        <ng-container *ngTemplateOutlet="textAttributeSection; context: { $implicit: attributes['7'] }"></ng-container>
      }
    </ng-template>

    <ng-template #commands>
      @if (attributes['8']) {
        <ng-container *ngTemplateOutlet="textAttributeSection; context: { $implicit: attributes['8'] }"></ng-container>
      }
    </ng-template>
  }

  <div class="ms-auto mt-auto">
    <apm-button variant="secondary" (click)="closeDialog()">{{ '444714' | apmTranslate }}</apm-button>
  </div>
</div>
